import React from "react";
import MainLayout from "../components/MainLayout/MainLayout";
import Section from "../components/Section/Section";
import { ReactComponent as Svg404 } from "../assets/images/404.svg";

function PageNotFound() {
  return (
    <MainLayout linkColor="#333333">
      <Section
        style={{
          width: "100%",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "50px"
          }}
        >
          <Svg404 style={{width: "50%"}}/>
        </div>
      </Section>
    </MainLayout>
  );
}

export default PageNotFound;
